import { makeRequest } from 'utils/requestLogger';

export default (courseID) =>
  makeRequest('put', `/api/courses/${courseID}/toggle_archived_status`);



// WEBPACK FOOTER //
// ./src/app/services/courses/archiveCourse.js